import { useState } from 'react';
// components
import {
  IEditForm,
  CasEditForm,
  CasRHFSwitch,
  CasRHFTextField,
  CasRHFCurrencyField,
  CasStackRow,
} from 'src/compass/shared/components';
import {
  CasAsOfContainer,
  EntityInfoCMEAdditClearing,
  useDefaultAsOfValues,
} from 'src/compass/application/commissions';

// schema
import { CMEAdditionalClearingSchema } from './CMEAdditionalClearingSchema';

// ----------------------------------------------------------------------

export default function CMEAdditionalClearingForm({ row, onSaved }: IEditForm) {
  const { id } = row || {};

  const [asofReadonly, setAsofReadonly] = useState(false);

  const defaultValues = useDefaultAsOfValues(row, { isActive: true });

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaved}
      entity={EntityInfoCMEAdditClearing.entity}
      schema={CMEAdditionalClearingSchema}
    >
      <CasStackRow>
        <CasRHFTextField name="description" label="Description" />
        <CasRHFSwitch name="isActive" label="Active" />
      </CasStackRow>
      <CasAsOfContainer
        entityTitle="CME Additional Clearing AsOf"
        entityId={id}
        deleteChildEntity="Cme/AdditClearing/AsOf"
        initialAsOfList={row?.asOfs}
        initialAsOf={defaultValues.asOf}
        readOnly={asofReadonly}
        setReadOnly={setAsofReadonly}
      >
        <CasRHFCurrencyField
          name="asOf.amount"
          label="Amount"
          disabled={asofReadonly}
          fullWidth={false}
        />
      </CasAsOfContainer>
    </CasEditForm>
  );
}
